import { ValueType } from '../data-conversion';
import { Device } from '../device';
import { UUID } from '@ird/shared-base';

/**
 * @deprecated Please move your code to the specific domain and use DAO, DTO and model separation
 */
export class Sensor {
  deviceData: unknown;
  attachedToDevices?: string[];
  deprecated: boolean;
  devices: Array<Device>;
  fieldId: string;
  id: string;
  lastActiveNanos?: number;
  location: string;
  mappedOrRawUnit: string;
  metadata: { [k: string]: string };
  name: string;
  notes: string;
  sensorType: string;
  time: string;
  type: string;
  valueType?: ValueType;
  precision?: number;
  unit: string;
  userName: string;
  virtual?: boolean;
  tenantId?: UUID;
}
